import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';

import Layout from 'cirrus/Layout';

import { entities } from 'pages/store/schema';
import { getData, putData, clearData } from 'pages/store/actions/data';
import { getProcessing, getOrderedValues, getErrors } from 'pages/store/selectors';
import { actionTypes } from 'pages/store/actions/defaults';

import { formatForAPI, formatForForm } from './utils/format';

import Industries from './Industries';

const errorMessage = 'An error occured, please try again later or contact support';

class VendorCatalogs extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getData('/admin/settings/industries');

    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            type: 'ui_tab',
            text: 'Inventory',
            name: 'inventory',
          },
          {
            text: 'Vendor Catalogs',
          },
        ],
      },
    });
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  handleSubmit(values, { resetForm }) {
    this.props.putData('/admin/settings/industries', formatForAPI(values, 'industries'), () => {
      window.flashNotifier('success', 'Saved changes.', 3);
      // This makes sure that the form data is synced with the returned API data
      resetForm();
    });
  }

  render() {
    const { industries, isLoading, loadingErrors, isSaving, savingErrors } = this.props;
    const errors = [errorMessage];
    const hasErrors = !!(loadingErrors || savingErrors);
    const initialValues = formatForForm(industries);

    return (
      <div className="cirrus cr-sans-serif" data-test="inventory-vendor-catalogs-root">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          render={formikProps => {
            const { handleSubmit, dirty } = formikProps;

            return (
              <Fragment>
                <header className="cr-bg-snow-300 cr-p-2 cr-border-bottom-1 cr-border-gray-100">
                  <div className="cr-max-width-content cr-display-block-centered">
                    <Button
                      variant="secondary"
                      fill
                      loading={isSaving}
                      disabled={isLoading || !dirty}
                      onClick={handleSubmit}
                      data-test="vendor-catalogs-save-button"
                    >
                      Save Changes
                    </Button>
                  </div>
                </header>

                {hasErrors && (
                  <div className="cr-p-2">
                    <div
                      className="cr-max-width-content cr-display-block-centered"
                      data-test="vendor-catalogs-alert"
                    >
                      <Alert type="danger" noCloseBtn>
                        {errors.map(err => (
                          <p key={err} className="cr-m-0">
                            {err}
                          </p>
                        ))}
                      </Alert>
                    </div>
                  </div>
                )}

                <Layout>
                  <Industries isLoading={isLoading} industries={industries} />
                </Layout>
              </Fragment>
            );
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  industries: getOrderedValues(['name'], ['asc'])(entities.industries)(state),
  isLoading: getProcessing({
    entity: entities.industries,
    list: true,
    actionType: actionTypes.LOADING,
  })(state),
  isSaving: getProcessing({
    entity: entities.industries,
    list: true,
    actionType: actionTypes.SAVING,
  })(state),
  loadingErrors: getErrors({
    entity: entities.industries,
    list: true,
    actionType: actionTypes.LOADING,
  })(state),
  savingErrors: getErrors({
    entity: entities.industries,
    list: true,
    actionType: actionTypes.SAVING,
  })(state),
});

const mapDispatchToProps = dispatch => ({
  getData: (url, onError) =>
    dispatch(getData({ url, entity: entities.industries, list: true, onError })),
  putData: (url, data, onSuccess) =>
    dispatch(putData({ url, payload: data, entity: entities.industries, list: true, onSuccess })),
  clearData: () => dispatch(clearData([entities.industries])),
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorCatalogs);
